var VCA = VCA || {};

VCA.StepSecitonForm = (function ($) {
    var ui = {};

    function cacheUI() {
        ui.$stepSection = $('.js-form-section-step');
    }

    function init() {
        if ($('.js-form-section-step').length <= 0) {
            return;
        }
        cacheUI();
        bindNextSectionClick();
        bindbackClick();
    }


    function bindNextSectionClick() {
        ui.$stepSection.on('click', '.js-check-form-section', function (e) {
            e.preventDefault();
            let section = $(this).closest('.js-form-section-step');
            if(!checkform(section)){
                return;
            }else{
               section.hide();
               section.next().next().show();
            }
        });
    }


    function bindbackClick() {
        ui.$stepSection.on('click', '.js-back-section', function (e) {
            e.preventDefault();
            let section = $(this).closest('.js-form-section-step');
            section.hide();
            section.prev().prev().show();
        });
    }
    function checkform(section) {
        var mailFormat = /(^[a-zA-Z0-9_.]+[@]{1}[a-zA-Z0-9\-]+[\.][a-zA-Z]+$)/;
        var phoneReg = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;

        let requiredinputs = section.find('input[data-val-required]');
        let requiredselect = section.find('select[data-val-required]');
        let requiredtextarea = section.find('select[data-val-required]');
        let textReg = /^[a-zA-Z -]{2,60}$/;
    //    console.log('inputs',requiredinputs);
     //   console.log('sleect',requiredselect);

        let valid = true

        requiredinputs.each(function (index) {
            let el = $(this);
            var elmType = el.attr('type');
            if (elmType == 'tel') {
                let phone = el.val();
                if (!phoneReg.test(phone)) {
                   el.addClass('error');
                   el.closest('.form-label-group').addClass('error');
                    valid = false;
                } else {
                   el.removeClass('error');
                   el.closest('.form-label-group').removeClass('error');
                }
            } else if (elmType == 'email') {
                let email = el.val();
                if (!mailFormat.test(email)) {
                    el.addClass('error');
                    el.closest('.form-label-group').addClass('error');
                    valid = false;
                } else {
                    el.removeClass('error');
                    el.closest('.form-label-group').removeClass('error');
                }
            } else {
                if (el.val() == '') {
                    el.addClass('error');
                    el.closest('.form-label-group').addClass('error');
                    valid = false;
                } else {
                    el.removeClass('error');
                    el.closest('.form-label-group').removeClass('error');
                }
            }
            console.log(el.val());
        });
        requiredselect.each(function (index) {
            let el = $(this);
            if (el.val() == '' || el.val() == null) {
                el.addClass('error');
                el.closest('.form-label-group').addClass('error');
                valid = false;
            } else {
                el.removeClass('error');
                el.closest('.form-label-group').removeClass('error');
            }
        });
        requiredtextarea.each(function (index){
            let el = $(this);
            if(el.val() == '' || el.val() == null){
                el.addClass('error');
                el.closest('.form-label-group').addClass('error');
                valid = false;
            } else {
                el.removeClass('error');
                el.closest('.form-label-group').removeClass('error');
            }
        });

        return valid;
    }

    return {
       init: init
    };

})(jQuery);

$(function () {
    VCA.StepSecitonForm.init();
});


